var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "module dt-top" }, [
    _c(
      "div",
      {
        staticClass: "dt-top-bg",
        on: {
          click: function ($event) {
            return _vm.preventThis(_vm.e)
          },
        },
      },
      [
        _c("img", { attrs: { src: _vm.itemData.v_picurl } }),
        _vm._v(" "),
        _c("div", { staticClass: "mask" }),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "dt-wrap" }, [
      _c("header", { staticClass: "dt-header" }, [
        _c("a", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.backStatus,
              expression: "backStatus",
            },
          ],
          staticClass: "back",
          attrs: { uigs: "head_back" },
          on: { click: _vm.backPrev },
        }),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.headTitle))]),
        _vm._v(" "),
        _c("a", {
          staticClass: "home",
          attrs: {
            href: "/?source=node&spver=" + _vm.spver,
            uigs: "head_home",
          },
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "search",
          attrs: { href: "/hotsugg?spver=" + _vm.spver, uigs: "head_search" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dt-info-header-wap" }, [
        _c(
          "div",
          { staticClass: "dt-info-img" },
          [
            _c("Image-1", {
              attrs: {
                src: _vm.itemData.vpicurl ? _vm.vpicurl : _vm.itemData.v_picurl,
                iname: _vm.itemData.name + "剧照",
              },
            }),
            _vm._v(" "),
            _vm.itemData.play_status === "2"
              ? _c("span", { staticClass: "tag-vip" }, [_vm._v("VIP")])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "tag-mark" }, [
              _vm._v(_vm._s(_vm.formatScore(_vm.itemData.score))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "figure",
          { staticClass: "dt-info-box" },
          [
            _c("figcaption", [_vm._v(_vm._s(_vm.itemData.name))]),
            _vm._v(" "),
            _c(
              "p",
              {
                class: [
                  _vm.playInfoStatus ? "dt-info-tag" : "dt-info-tag two-line",
                ],
              },
              [
                _vm._l(_vm.infolist, function (v, index) {
                  return [
                    _c("span", { key: "info" + index }, [_vm._v(_vm._s(v))]),
                    _vm._v(" "),
                    index !== _vm.infolist.length - 1
                      ? _c("em", { key: "info_" + index }, [_vm._v("/")])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.text
              ? [
                  _c(
                    "p",
                    {
                      class: [
                        _vm.playInfoStatus
                          ? "dt-info-tag"
                          : "dt-info-tag two-line",
                      ],
                    },
                    [
                      typeof _vm.itemData.starring !== "undefined"
                        ? _c("span", [_vm._v("主演：")])
                        : typeof _vm.itemData.emcee !== "undefined"
                        ? _c("span", [_vm._v("主持：")])
                        : typeof _vm.itemData.shengyou !== "undefined"
                        ? _c("span", [_vm._v("声优：")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.text.split(";"), function (str, index) {
                        return [
                          index !== 0
                            ? _c("em", { key: "playinfo" + index }, [
                                _vm._v(" "),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              key: "playinfo_" + index,
                              attrs: {
                                href: _vm.searchResultUrl(str),
                                uigs: "basic_out",
                              },
                            },
                            [_vm._v(_vm._s(str))]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.itemData.director
              ? [
                  _c(
                    "p",
                    {
                      class: [
                        _vm.playInfoStatus
                          ? "dt-info-tag"
                          : "dt-info-tag two-line",
                      ],
                    },
                    [
                      _vm.type === "cartoon"
                        ? _c("span", [_vm._v("作者：")])
                        : _c("span", [_vm._v("导演：")]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.itemData.director.split(";"),
                        function (str, index) {
                          return [
                            index !== 0
                              ? _c("em", { key: "director" + index }, [
                                  _vm._v(" "),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                key: "director_" + index,
                                attrs: {
                                  href: _vm.searchResultUrl(str),
                                  uigs: "basic_out",
                                },
                              },
                              [_vm._v(_vm._s(str))]
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.itemData.update_wordstr
              ? _c("p", { staticClass: "dt-info-tag" }, [
                  _c("span", [_vm._v("更新时间：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.itemData.update_wordstr))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.itemData.tv_station
              ? _c(
                  "p",
                  { staticClass: "dt-info-tag", attrs: { id: "tv_station" } },
                  [
                    _c("span", [_vm._v("电视台：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.itemData.tv_station))]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.itemData.release_time && _vm.isShowReleaseTime
              ? _c(
                  "p",
                  { staticClass: "dt-info-tag", attrs: { id: "release_time" } },
                  [
                    _c("span", [_vm._v("上映时间：")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.itemData.release_time))]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "dt-play-btn" }, [
              _c("div", { staticClass: "dt-play-btn" }, [
                _vm.playInfo.length >= 1
                  ? _c(
                      "div",
                      {
                        staticClass: "dt-source",
                        attrs: { id: "dt-site-source" },
                        on: { click: _vm.showSiteList },
                      },
                      [
                        _c(
                          "p",
                          {
                            class: [
                              "dt-source-item",
                              "first",
                              _vm.playInfo.length === 1 ? "hide" : "",
                            ],
                          },
                          [
                            _vm.initPlayInfo.icon
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      _vm.itemData.imgpath +
                                      "/logo/" +
                                      _vm.initPlayInfo.icon,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "dt-source-item-first" },
                              [_vm._v(_vm._s(_vm.initPlayInfo.siteName))]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.playInfo.length > 0
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.playInfoStatus,
                            expression: "playInfoStatus",
                          },
                        ],
                        staticClass: "dt-info-box-btm",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "btn",
                            attrs: {
                              href: _vm.initPlayInfo.url,
                              uigs:
                                _vm.itemData.play_status === "3"
                                  ? "preview_play"
                                  : "btn_play",
                              uigsparams: `play_type=lvideo&play_url=${encodeURIComponent(
                                _vm.initPlayInfo.ourl
                              )}&play_site=${_vm.initPlayInfo.domain}`,
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.itemData.play_status === "3"
                                    ? "预告片"
                                    : "立即播放"
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.playInfo.length > 1
              ? [
                  _c("LayerSelect", {
                    attrs: {
                      "list-data": _vm.playInfo,
                      "select-title": "选择来源",
                      "cur-data": _vm.initPlayInfo,
                      "get-name": _vm.getSiteName,
                      "get-icon": _vm.getSiteIcon,
                      "layer-show": _vm.isSiteListShow,
                    },
                    on: {
                      "change-list-item": _vm.changePlayInfo,
                      "hidden-layer": _vm.hiddenLayer,
                    },
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.itemData.introduction,
              expression: "itemData.introduction",
            },
          ],
          class: [
            "dt-info-intro",
            { fold: _vm.isFold === true },
            { hideIntro: _vm.itemData.hideIntro === 1 },
          ],
        },
        [
          _vm.itemData.introduction && _vm.itemData.introduction.trim()
            ? _c("div", { staticClass: "con" }, [
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.itemData.hideIntro !== 1,
                        expression: "itemData.hideIntro !== 1",
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.toggleFold(_vm.itemData.introduction)
                      },
                    },
                  },
                  [
                    _vm.itemData.introduction &&
                    _vm.itemData.introduction.trim()
                      ? _c("em", [_vm._v("剧情简介 : ")])
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.itemData.introduction) + "\n        "),
                  ]
                ),
                _vm._v(" "),
                _vm.itemData.alais_name.length > 0 && false
                  ? _c(
                      "p",
                      { staticClass: "other-name" },
                      [
                        _c("em", [_vm._v("别名 : ")]),
                        _vm._v(" "),
                        _vm._l(_vm.itemData.alais_name, function (v, index) {
                          return _c(
                            "a",
                            {
                              key: "alais" + index,
                              attrs: {
                                href: v.url,
                                title: v.name,
                                uigs: "alias_out",
                              },
                            },
                            [_c("span", [_vm._v(" " + _vm._s(v.name) + ";")])]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dockey.indexOf("film_") > -1 &&
                _vm.plotInfo &&
                _vm.plotInfo.show &&
                false
                  ? _c(
                      "a",
                      { attrs: { href: "/s/plot/" + _vm.dockey + ".html" } },
                      [_vm._v("\n          查看完整剧情\n        ")]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getByteLength(_vm.itemData.introduction) > 102 &&
          +_vm.itemData.hideIntro !== 1
            ? _c("div", {
                staticClass: "dt-info-intro-more",
                on: {
                  click: function ($event) {
                    return _vm.toggleFold(_vm.itemData.introduction)
                  },
                },
              })
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }